import { MessageCircle } from "lucide-react";
import { PERAHAN_INFO } from "@/lib/constants";

export default function WhatsAppButton() {
  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hello! I'm interested in Perahan's collection. Could you please provide more information?");
    window.open(`https://wa.me/${PERAHAN_INFO.whatsapp.replace(/\D/g, '')}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleWhatsApp}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 group"
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle size={24} className="group-hover:animate-pulse" />
      </button>
    </div>
  );
}
